import { AG_GRID_LICENSE_KEY } from './agGridLicense'

let initialized = false
let initPromise: Promise<void> | null = null

/** Loads AG Grid Enterprise once and applies the license (call before rendering any grid). */
export function initAgGrid(): Promise<void> {
  if (initialized) {
    return Promise.resolve()
  }

  if (!initPromise) {
    initPromise = import('ag-grid-enterprise').then(({ LicenseManager }) => {
      LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY)
      initialized = true
    })
  }

  return initPromise
}
